import React from 'react';

import {
  InnerContainer,
  Content,
  CakeImg,
  Actions,
  Text,
  Title,
  StyledLinkV2,
} from './ErrorPage.styles';

import CAKE_DOG_404 from '../../assets/images/errorPage/404_DogCake.svg';

export type ErrorPageProps = {
  statusCode: number;
};

const ErrorPage = (props: ErrorPageProps): JSX.Element => {
  const { statusCode = 404 } = props;
  const titleText = statusCode === 404 ? 'Page not found' : 'Error occurred';

  return (
    <InnerContainer>
      <Content>
        <CakeImg src={CAKE_DOG_404} alt="" />
        <Actions>
          <Title>Whoops, party foul. {titleText}.</Title>
          <Text>
            Something went wrong on our end. While we figure it out, let&apos;s get you back to the
            party.
          </Text>
          <StyledLinkV2 href="/search/wedding-registry" arrow inline>
            Find a Couple
          </StyledLinkV2>
          <StyledLinkV2 href="/onboard/new" arrow inline>
            Start a Registry
          </StyledLinkV2>
          <StyledLinkV2 href="/wedding-planning/save-the-date/shop" arrow>
            Shop Invites &amp; Paper
          </StyledLinkV2>
          <StyledLinkV2 href="/wedding-vendors" arrow>
            Explore Wedding Vendors
          </StyledLinkV2>
        </Actions>
      </Content>
    </InnerContainer>
  );
};

export default ErrorPage;
